export const partnerResources = {
  'partner.config.volumeEstimates.title': 'Product Page View Estimates',
  'partner.config.volumeEstimates.description': `In order to make sure we are prepared for the volume of traffic we can expect, please provide the following estimates. You can generally get these from Google Analytics or other similar marketing or site/store management platforms.`,

  'partner.config.volumeEstimates.weeklyAvg.label': 'Average Product Page Weekly Volume',
  'partner.config.volumeEstimates.weeklyPeak.label': 'Peak Product Page Weekly Volume',
  'partner.config.volumeEstimates.dailyAvg.label': 'Average Product Page Daily Volume',
  'partner.config.volumeEstimates.dailyPeak.label': 'Peak Product Page Daily Volume',
  'partner.config.volumeEstimates.hourlyAvg.label': 'Average Product Page Hourly Volume',
  'partner.config.volumeEstimates.hourlyPeak.label': 'Peak Product Page Hourly Volume',

  'partner.config.volumeEstimates.weeklyAvg.description':
    'The average number of product page views that your site receives in a week.',
  'partner.config.volumeEstimates.weeklyPeak.description':
    'The maximum number of product page views that you anticipate receiving in a week.',
  'partner.config.volumeEstimates.dailyAvg.description':
    'The average number of product page views that your site receives on a daily basis.',
  'partner.config.volumeEstimates.dailyPeak.description':
    'The maximum number of product page views that your site receives on a daily basis.',
  'partner.config.volumeEstimates.hourlyAvg.description':
    'The average number of product page views that your site receives on an hourly basis.',
  'partner.config.volumeEstimates.hourlyPeak.description':
    'The maximum number of product page views that your site receives on an hourly basis.',

  'partner.config.reportingConfiguration.title': 'Reporting Configuration',
  'partner.config.reportingConfiguration.description':
    'The following reporting settings apply to all users within your organization.',

  'partner.config.reportingTimezone.label': 'Reporting Timezone',
  'partner.config.reportingTimezone.description':
    'The timezone to use when viewing all reports, metrics and statistics.',

  'partner.config.reportingConfiguration.startOfWeek.label': 'Start of Week',
  'partner.config.reportingConfiguration.startOfWeek.description': `The first day of your company's reporting week.`,

  'partner.config.reportingConfiguration.orderToShipSlaDays.label': 'Order to Ship SLA Days',
  'partner.config.reportingConfiguration.orderToShipSlaDays.description':
    'The expected number of days between order and ship.',

  'partner.config.reportingConfiguration.orderToDeliverSlaDays.label': 'Order to Deliver SLA Days',
  'partner.config.reportingConfiguration.orderToDeliverSlaDays.description':
    'The expected number of days between order and delivery.',

  'partner.config.cancel': 'Cancel',
  'partner.config.save': 'Save',

  'partner.config.reportingConfiguration.successMessage': 'Successfully updated reporting configuration.',
  'partner.config.reportingConfiguration.errorMessage':
    'An error occurred while attempting to update the reporting configuration.  Please retry.',

  'partner.config.volumeEstimates.successMessage': 'Successfully updated page view volume estimates.',
  'partner.config.volumeEstimates.errorMessage':
    'An error occurred while attempting to update volume estimates.  Please retry.',

  'partner.packaging.helpReformatMessage': 'Will be automatically reformatted to length>width>height',
};
export type PartnerResourceKey =
  | 'partner.config.volumeEstimates.title'
  | 'partner.config.volumeEstimates.description'
  | 'partner.config.volumeEstimates.weeklyAvg.label'
  | 'partner.config.volumeEstimates.weeklyPeak.label'
  | 'partner.config.volumeEstimates.dailyAvg.label'
  | 'partner.config.volumeEstimates.dailyPeak.label'
  | 'partner.config.volumeEstimates.hourlyAvg.label'
  | 'partner.config.volumeEstimates.hourlyPeak.label'
  | 'partner.config.volumeEstimates.weeklyAvg.description'
  | 'partner.config.volumeEstimates.weeklyPeak.description'
  | 'partner.config.volumeEstimates.dailyAvg.description'
  | 'partner.config.volumeEstimates.dailyPeak.description'
  | 'partner.config.volumeEstimates.hourlyAvg.description'
  | 'partner.config.volumeEstimates.hourlyPeak.description'
  | 'partner.config.reportingConfiguration.title'
  | 'partner.config.reportingConfiguration.description'
  | 'partner.config.reportingTimezone.label'
  | 'partner.config.reportingTimezone.description'
  | 'partner.config.reportingConfiguration.startOfWeek.label'
  | 'partner.config.reportingConfiguration.startOfWeek.description'
  | 'partner.config.reportingConfiguration.orderToShipSlaDays.label'
  | 'partner.config.reportingConfiguration.orderToShipSlaDays.description'
  | 'partner.config.reportingConfiguration.orderToDeliverSlaDays.label'
  | 'partner.config.reportingConfiguration.orderToDeliverSlaDays.description'
  | 'partner.config.cancel'
  | 'partner.config.save'
  | 'partner.config.reportingConfiguration.successMessage'
  | 'partner.config.reportingConfiguration.errorMessage'
  | 'partner.config.volumeEstimates.successMessage'
  | 'partner.config.volumeEstimates.errorMessage'
  | 'partner.packaging.helpReformatMessage';
